import classes from "./Suggestions.module.css";

const Suggestions = ({ suggestions, onSelect }) => {
  return (
    <div className={classes.suggestions}>
      {suggestions?.map((text, i) => (
        <button key={i} className={classes.suggestion} onClick={() => onSelect(text)}>
          <span>{text}</span>
        </button>
      ))}
    </div>
  );
};

export default Suggestions;